// Файловые web-хелперы. Перенесено из src/features/edo/processUI.tsx (было импортом ЭДО-модуля
// для несвязанных экранов вроде news.tsx/profile.tsx).
import { Platform } from 'react-native'

/** Web-only file picker (в проекте нет native document-picker) → File | null. */
export function pickFileWeb(accept: string): Promise<File | null> {
  return new Promise((resolve) => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return resolve(null)
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = accept
    input.onchange = () => resolve(input.files?.[0] ?? null)
    input.click()
  })
}

/** То же, но несколько файлов за раз (`<input multiple>`) → File[] (пусто — ничего не выбрали). */
export function pickFilesWeb(accept: string): Promise<File[]> {
  return new Promise((resolve) => {
    if (Platform.OS !== 'web' || typeof document === 'undefined') return resolve([])
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = accept
    input.multiple = true
    input.onchange = () => resolve(Array.from(input.files ?? []))
    input.click()
  })
}
